import { profileUsesDimension } from '../../utils/productDimensions';

export const ORDER_PRODUCT_MAX_DIMENSION_MM = 50_000;
export const ORDER_PRODUCT_SALE_DIMENSION_FIELDS = ['length', 'width', 'thickness'] as const;

type DimensionValue = number | string | null | undefined;
type Translate = (key: string, options?: Record<string, unknown>) => string;

export const formatOrderProductMaxDimension = (language?: string) =>
  ORDER_PRODUCT_MAX_DIMENSION_MM.toLocaleString(language?.startsWith('pl') ? 'pl-PL' : 'en-US');

export const createOrderProductDimensionRule = (t: Translate, language?: string) => ({
  validator: async (_: unknown, value: DimensionValue) => {
    if (value === null || value === undefined || value === '') {
      return;
    }

    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0) {
      throw new Error(t('orders:orderDetail.messages.dimensionInvalid'));
    }

    if (parsed > ORDER_PRODUCT_MAX_DIMENSION_MM) {
      throw new Error(t('orders:orderDetail.messages.dimensionTooLarge', {
        max: formatOrderProductMaxDimension(language),
      }));
    }
  },
});

export const omitUnusedOrderProductHeight = <
  T extends { height?: unknown; productCategoryDimensionDisplayProfile?: string | null; dimensionDisplayProfile?: string | null }
>(product: T): T | (Omit<T, 'height'> & { height?: undefined }) => {
  if (profileUsesDimension(
    product.productCategoryDimensionDisplayProfile ?? product.dimensionDisplayProfile,
    'height',
  )) {
    return product;
  }

  return {
    ...product,
    height: undefined,
  };
};
